// capacitor
import {
  InAppBrowser,
  DefaultSystemBrowserOptions,
  iOSViewStyle,
  AndroidViewStyle,
} from '@capacitor/inappbrowser';

/**
 * __openInPopover is a function that opens a URL in the system browser.
 * It is used to intercept redirects and open them in a popover on iOS and Android.
 */
(window as any).__openInPopover = (url: string) => {
  console.log('[Intercepted Redirect]', url);
  InAppBrowser.openInSystemBrowser({
    url: url.replace('"', ''),
    options: {
      ...DefaultSystemBrowserOptions,
      iOS: {
        ...DefaultSystemBrowserOptions.iOS,
        viewStyle: iOSViewStyle.FORM_SHEET,
      },
      android: {
        ...DefaultSystemBrowserOptions.android,
        viewStyle: AndroidViewStyle.BOTTOM_SHEET,
      },
    },
  });
  return;
};
